import { paths } from '../../common/constants/pathVariables.js';
import {
  messageCenterMsg,
  orderConfirmationsMsg,
  supportCasesAndMessagesMsg,
  t,
  warrantyReceiptsMsg,
} from '../../common/i18n';
import { Grid } from '../Grid/Grid';
import { HeroHeading, HeroHeadingType } from '../HeroHeading';
import { LocalNavi } from '../LocalNavi';
import type { BreadCrumbList } from '../BreadCrumbs';
import type { LocalNaviItem } from '../LocalNavi';
import type { ReactNode } from 'react';

import './MessageCenter.scss';

interface MessageCenterProps {
  breadCrumbs?: BreadCrumbList;
  children: ReactNode;
}

export const getDisplayCategories = () => {
  return [
    {
      children: t.NPCK(supportCasesAndMessagesMsg),
      to: paths.MESSAGE_CENTER_SUPPORT_CASES,
    },
    {
      children: t.I86M(orderConfirmationsMsg),
      to: paths.MESSAGE_CENTER_ORDER_CONFIRMATIONS,
    },
    {
      children: t.SZY8(warrantyReceiptsMsg),
      to: paths.MESSAGE_CENTER_WARRANTY_RECEIPTS,
    },
  ].filter(Boolean) as LocalNaviItem[];
};

export const MessageCenter = ({ breadCrumbs, children }: MessageCenterProps) => {
  const displayCategories = getDisplayCategories();

  return (
    <div className="of-message-center">
      <HeroHeading
        breadCrumbPaths={breadCrumbs}
        heroHeadingType={HeroHeadingType.MESSAGE_CENTER}
        title={t.O5C5(messageCenterMsg)}
      />
      <LocalNavi wide categories={displayCategories} />
      <Grid>{children}</Grid>
    </div>
  );
};
